import { Row } from "./Row";
import TopMenu from "./TopMenu";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
} from "@mui/material";
import ShowMoreButton from "../../global/ShowMoreButton";

export default function AppointmentsTable({
  caseInfo,
  apptSearch,
  setApptSearch,
  loading,
  appointments,
  activeBills,
  handleApptDelete,
  handleProviderApptEdit,
  setProvider,
  setProviderDetailDisplay,
  handleUploadDocument,
  showMoreApptsVisible,
  setApptResLimit,
  apptResLimit,
  proCliTrigger,
  setProCliTrigger,
}) {
  return (
    <TableContainer
      component={Paper}
      data-id="collapsible-table"
      className="max-h-[80vh] overflow-auto"
    >
      <TopMenu
        caseInfo={caseInfo}
        apptSearch={apptSearch}
        setApptSearch={setApptSearch}
      />
      {loading ? (
        <div className="pb-2 mt-2">
          <div className="mx-auto w-fit">
            <CircularProgress color="secondary" />
          </div>
        </div>
      ) : (
        <>
          <Table aria-label="collapsible table" stickyHeader>
            <TableHead>
              <TableRow data-id="collapsible-table-headers">
                <TableCell align="left" className="font-bold">
                  Provider&nbsp;Location
                </TableCell>
                <TableCell align="left" className="font-bold">
                  Type
                </TableCell>
                <TableCell align="left" className="font-bold">
                  Date&nbsp;&&nbsp;Time
                </TableCell>
                <TableCell align="center" className="font-bold">
                  Status
                </TableCell>
                <TableCell align="center" className="font-bold">
                  Documents
                </TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {appointments.map((row, index) => {
                return (
                  <Row
                    key={index}
                    row={row}
                    activeBills={activeBills}
                    caseInfo={caseInfo}
                    handleApptDelete={handleApptDelete}
                    handleProviderApptEdit={handleProviderApptEdit}
                    setProvider={setProvider}
                    setProviderDetailDisplay={setProviderDetailDisplay}
                    handleUploadDocument={handleUploadDocument}
                    proCliTrigger={proCliTrigger}
                    setProCliTrigger={setProCliTrigger}
                  />
                );
              })}
            </TableBody>
          </Table>
          <ShowMoreButton
            showMoreVisible={showMoreApptsVisible}
            setResLimit={setApptResLimit}
            resLimit={apptResLimit}
            showMoreAmt={5}
          />
        </>
      )}
    </TableContainer>
  );
}
